const greenTheme = {
  themePrimary: "#73b944",
  themeHoverPrimary: "#58942f",
  themeGray: "#c0c0c0",
  white: "#FFF",
};

export const colors = greenTheme;
